// One signal for "orders changed" (an order was accepted, rejected or placed), so every part of the admin panel that
// shows orders (the new order alarm, Manage orders, the pending badges) updates at once instead of after a refresh
const EVENT = "ownezzy:orders-changed";

export const ordersChanged = () => window.dispatchEvent(new Event(EVENT));

// Calls fn on every change; returns the function that stops listening
export function onOrdersChanged(fn) {
  window.addEventListener(EVENT, fn);
  return () => window.removeEventListener(EVENT, fn);
}
